import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DEFAULT_CONTENT_STATE } from "./constants";
import { IContentState } from "./interfaces";
import { TWebActiveContent } from "~/interfaces";

const contentSlice = createSlice({
	name: "content",
	initialState: DEFAULT_CONTENT_STATE,
	reducers: {
		/* pro kontenty map */
		addActiveContent: (state: IContentState, action: PayloadAction<TWebActiveContent>) => {
			const content = action.payload;

			if (state.activeContents.indexOf(content) === -1) {
				state.activeContents.push(content);
			}
		},
		removeActiveContent: (state: IContentState, action: PayloadAction<TWebActiveContent>) => {
			const content = action.payload;
			const ind = state.activeContents.indexOf(content);

			if (ind !== -1) {
				const activeContents = state.activeContents.slice();

				activeContents.splice(ind, 1);
				state.activeContents = activeContents;
			}
		},
	},
});

export const { addActiveContent, removeActiveContent } = contentSlice.actions;
export default contentSlice.reducer;
